"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FREE_SERVICE_PROFESSIONAL_ONBOARDING = exports.FREE_CRM_SALES_STARTER_KIT = void 0;

var _enviro = _interopRequireDefault(require("self-service-api/core/utilities/enviro"));

var isProd = _enviro.default.isProd();

var FREE_CRM_SALES_STARTER_KIT_PROD = 56;
var FREE_CRM_SALES_STARTER_KIT_QA = 119;
var FREE_SERVICE_PROFESSIONAL_ONBOARDING_PROD = 60;
var FREE_SERVICE_PROFESSIONAL_ONBOARDING_QA = 122;
var FREE_CRM_SALES_STARTER_KIT = isProd ? FREE_CRM_SALES_STARTER_KIT_PROD : FREE_CRM_SALES_STARTER_KIT_QA;
exports.FREE_CRM_SALES_STARTER_KIT = FREE_CRM_SALES_STARTER_KIT;
var FREE_SERVICE_PROFESSIONAL_ONBOARDING = isProd ? FREE_SERVICE_PROFESSIONAL_ONBOARDING_PROD : FREE_SERVICE_PROFESSIONAL_ONBOARDING_QA;
exports.FREE_SERVICE_PROFESSIONAL_ONBOARDING = FREE_SERVICE_PROFESSIONAL_ONBOARDING;